import { render, staticRenderFns } from "./Lgx328192071175241728.vue?vue&type=template&id=834e5e4c&"
import script from "./Lgx328192071175241728.vue?vue&type=script&lang=js&"
export * from "./Lgx328192071175241728.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports